import React from 'react';
import moment from 'moment/moment';
import {DefaultCell} from '../Table';
import {useNavigate} from 'react-router-dom';

const MissedInspections = ({
  action,
  setCurrentMissedIns,
  rowIndex,
  cellKeys,
}) => {
  const navigate = useNavigate();
  const rowClick = () => {
    setCurrentMissedIns(action);

    setTimeout(() => {
      navigate('/inspections/' + action?.id);
    }, 500);
  };

  return (
    <tr
      className='table-row'
      key={action.id}
      style={{
        gridTemplateColumns: `repeat(${cellKeys.length}, 1fr)`,
      }}
      onClick={rowClick}
    >
      <DefaultCell
        value={action?.name ? action?.name : '---'}
        index='name'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={action?.equipment?.title ? action?.equipment?.title : '---'}
        index='equipment'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={action?.status ? action?.status : '---'}
        index='status'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={action?.facility?.name ? action?.facility?.name : '---'}
        index='facility'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={
          action?.inspection_date
            ? moment(action?.inspection_date)?.format('MM/DD/YYYY')
            : '---'
        }
        index='inspection_date'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={
          action?.due_date_fbo_timezone
            ? moment(action?.due_date_fbo_timezone)?.format(
                'MM/DD/YYYY hh:mm A',
              )
            : '---'
        }
        index='due_date_fbo_timezone'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={
          action?.period?.charAt(0)?.toUpperCase() + action?.period?.slice(1)
        }
        index='period'
        rowIndex={rowIndex}
      />
    </tr>
  );
};

export default MissedInspections;
